import { Button, Card, Modal, Space, Table, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { LoadingState } from "../components/LoadingState";
import { useApi } from "../hooks/useApi";
import { api } from "../services/api";

export default function Home() {
  const [helloMessage, setHelloMessage] = useState("");
  const [users, setUsers] = useState([]);
  const { loading, error, callApi } = useApi();

  const fetchHello = useCallback(async () => {
    try {
      const data = await callApi(() => api.getHello());
      if (data?.message) {
        setHelloMessage(data.message);
      }
    } catch (err) {
      message.error(`Failed to fetch hello message: ${err.message}`);
    }
  }, [callApi]);

  const fetchUsers = useCallback(async () => {
    try {
      const data = await callApi(() => api.getUsers());
      if (data) {
        setUsers(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      message.error(`Failed to fetch users: ${err.message}`);
    }
  }, [callApi]);

  useEffect(() => {
    fetchHello();
    fetchUsers();
  }, [fetchHello, fetchUsers]);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
  ];

  if (loading) return <LoadingState />;

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Card title="API Test">
        {error ? (
          <div style={{ color: "red" }}>{error}</div>
        ) : (
          <p>{helloMessage || "No message available"}</p>
        )}
        <Button type="primary" onClick={fetchHello} loading={loading}>
          Refresh Hello Message
        </Button>
      </Card>

      <Card title="Users">
        <Table
          dataSource={users}
          columns={columns}
          rowKey="id"
          pagination={false}
          loading={loading}
          onRow={(record) => ({
            onClick: () => {
              Modal.info({
                title: `User Details: ${record.username}`,
                content: (
                  <div>
                    <p>
                      <strong>ID:</strong> {record.id}
                    </p>
                    <p>
                      <strong>Username:</strong> {record.username}
                    </p>
                    <p>
                      <strong>Email:</strong> {record.email}
                    </p>
                    <p>
                      <strong>Created:</strong> {new Date(record.created_at).toLocaleString()}
                    </p>
                    <p>
                      <strong>Updated:</strong> {new Date(record.updated_at).toLocaleString()}
                    </p>
                  </div>
                ),
              });
            },
          })}
        />
        <Button type="primary" onClick={fetchUsers} style={{ marginTop: 16 }} loading={loading}>
          Refresh Users
        </Button>
      </Card>
      <Card title="Test">
        <p>Test Card</p>
      </Card>
      <Card title="Hallo Welt">
        <p>Test Card</p>
      </Card>
    </Space>
  );
}
// test
// test
